import { unreachable } from '@aloft/toolkit-shared';

import { TkOrderListField, TkOrderListing } from '../types.ts';

export const getTkv2SortAccessor = (field: TkOrderListField) => {
  switch (field) {
    case 'address':
      return (order: TkOrderListing) => order.address?.AddressLineText;
    case 'propertyType':
    case 'effectiveDate':
      return (order: TkOrderListing) =>
        order.isCompleted ? (order.signedAt ?? order.createdAt) : order.createdAt;
    case 'clientName':
      return (order: TkOrderListing) => order.clientName ?? '';
    case 'appraisalType':
      return (order: TkOrderListing) => order.appraisalType ?? '';
    case 'tags':
      return (order: TkOrderListing) => (order.tags?.length ? order.tags.join(', ') : '');
    default:
      unreachable(field);
  }
};
